import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddDriverRequest } from '../models/request/driver/AddDriverRequest';
import { GetDriverListPagingAndFilterRequest } from '../models/request/driver/GetDriverListPagingAndFilterRequest';
import { MrzResponse } from '../models/response/mrz/MrzResponse';

export class DriverService {
    /**
     * @param _relatedCompanyId Verilirse yalniz "Bagli Oldugu Firma" bu olan suruculer doner.
     *                          Seferde tedarikci secilince surucu listesi o firmaya daraltilir.
     */
    static async getDriverList(_relatedCompanyId: string | undefined = undefined) {
        try {
            var inputObj = {
                selectedRelatedCompanies: _relatedCompanyId ? [{ label: '', value: _relatedCompanyId }] : []
            };

            console.log('SERVICE CALL - getDriverList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Driver/getDriverList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportDriverList(inputObj: GetDriverListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportDriverList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Driver/exportDriverList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDriverListPagingAndFilter(inputObj: GetDriverListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetDriverListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Driver/GetDriverListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addDriver(inputObj: AddDriverRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddDriver', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Driver/AddDriver', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteDriver(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteDriver', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Driver/deleteDriver', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDriverById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getDriverById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Driver/getDriverById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addDriverByMrz(inputObj: MrzResponse) {
        try {
            console.log('SERVICE CALL - addDriverByMrz', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Driver/addDriverByMrz', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}